import { Swiper } from '@theme/swiper';

const el = document.querySelector('.product-swiper');

if (el) {
  const preloadLink = document.querySelector('link[rel="preload"][href*="swiper-bundle.min.css"]');
  if (preloadLink) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = preloadLink.href;
    document.head.appendChild(link);
  }

  window.productSwiper = new Swiper(el, {
    loop: false,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}